// extracted by mini-css-extract-plugin
module.exports = {"order-input":"_1MjU7j0F","label":"_3U4r6lVw","input-wrapper":"sY8FHYDK","input":"TSGTkiKQ","btn":"_1r83QOi9","btn-icon":"_1vSijFHp"};